export abstract class Base {
    abstract toInterface(): any;
}